export default {
  'Fall 2020': [
    {
      id: 0,
      title: 'Jeremiah',
      description:
        'This course will survey the book of Jeremiah, observing the various themes and topics in the book, and especially how the rest of Scripture comments on Jeremiah. Other topics of interest will also be discussed, such as Christ in the book of Jeremiah and inspiration of the book.',
      time: 'Monday, 6:00pm-7:45pm',
      syllabus: 'Jeremiah.pdf',
    },
    {
      id: 1,
      title: 'Old Testament Survey I',
      description:
        'This course surveys the Old Testament from Genesis through Esther, observing various themes and topics of each book. Other topics of interest will also be discussed, such as Christ in the Old Testament, the canon of the Old Testament, and inspiration.',
      time: 'Monday, 8:00pm-9:45pm',
      syllabus: 'Old Testament Survey 1.pdf',
    },
    {
      id: 2,
      title: 'Hebrew I',
      lang: 'א',
      description:
        'An Introduction to the Hebrew language, with emphasis on the phonology (sounds), morphology (forms), and basic vocabulary of biblical Hebrew.',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Hebrew 1.pdf',
    },
    {
      id: 3,
      title: 'Hebrew Composition',
      lang: 'א',
      description:
        'This course will emphasize the syntax, accents, and exgesis of biblical Hebrew through original Hebrew composition.',
      time: '',
      syllabus: 'Hebrew Composition.pdf',
    },
    {
      id: 4,
      title: 'Jeremiah',
      lang: 'א',
      description:
        'An Introduction to Jeremiah in Hebrew, with an emphasis in reading comprehension, exegesis, and theology of the book.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'Jeremiah in Hebrew.pdf',
    },
  ],
  'Winter 2021': [
    {
      id: 1,
      title: 'Greek 1',
      instructor: 'Russell Fuller',
      lang: 'α',
      description:
        'This course will cover the first eighteen chapters of the textbook: two chapters one week, one chapter and a review the next week. The course will emphasize the phonology (sounds) and the morphology (forms), along with a basic vocabulary of biblical Greek.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'Greek1Spring.pdf',
    },
    {
      id: 2,
      title: 'Greek 3',
      instructor: 'Russell Fuller',
      lang: 'α',
      description:
        'This course is an advanced study of Greek phonology and morphology. This class will help the student understand the inflection of words, parsing, and principal parts of Greek. To take this course you need to have taken Greek I and II or their equivalent, that is, to have completed a first-year Greek grammar.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'Greek3PhonologyAndMorphology.pdf',
    },
    {
      id: 3,
      title: 'Hebrew 1',
      instructor: 'Richard McDonald',
      lang: 'א',
      description:
        'An Introduction to the Hebrew language, with emphasis on the phonology (sounds), morphology (forms), and basic vocabulary of biblical Hebrew.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'Hebrew1Spring.pdf',
    },
    {
      id: 4,
      title: 'Hebrew 2',
      instructor: 'Richard McDonald',
      lang: 'א',
      description:
        'This course will cover the last fourteen chapters of the textbook, one chapter per week usually and two chapters in the first week. The course will emphasize the weak verb, its phonology (the sounds) and morphology (the forms), along with a basic vocabulary of biblical Hebrew.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'Hebrew2Spring.pdf',
    },
    {
      id: 5,
      title: 'Hebrew Exegesis: Numbers',
      instructor: 'Kyoungwon Choi',
      lang: 'א',
      description:
        'This course focuses on reading selected passages in the Hebrew of the book of Numbers, emphasizing the syntax, exegesis, and theology of the book. To take this course you need to have taken Hebrew I and II or their equivalent, that is, to have completed a first-year Hebrew grammar.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'HebrewExegesisNumbers.pdf',
    },
    {
      id: 6,
      title: 'Hebrews',
      instructor: 'Russell Fuller',
      description:
        'This course overviews the Epistle to the Hebrews, observing various themes and topics in the book, and especially how the rest of Scriptures (the Old Testament in particular) helps to interpret the book of Hebrews, and just as importantly, how the book of Hebrews interprets the Old Testament. Other topics of interest will also be discussed, such as the authorship and inspiration of the book of Hebrews, among others.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'Hebrews.pdf',
    },
    {
      id: 7,
      title: 'Old Testament Survey 2',
      instructor: 'Russell Fuller',
      description:
        'This course surveys the Old Testament from Job through Malachi, observing various themes and topics of each book. Other topics of interest will also be discussed, such as Christ in the Old Testament, Old Testament poetry, and Old Testament prophecy.',
      time: 'Tuesday & Thursday, 8:00pm-8:50pm',
      syllabus: 'OldTestamentSurvey2.pdf',
    },
  ],
  'Fall 2021': [
    {
      id: 1,
      title: 'Hebrew 1',
      instructor: 'Kyoungwon Choi',
      lang: 'א',
      description:
        'An Introduction to the Hebrew language, with emphasis on the phonology (sounds), morphology (forms), and basic vocabulary of biblical Hebrew.',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Hebrew 1 Fall.pdf',
    },
    {
      id: 2,
      title: 'Greek 2',
      instructor: 'Russell Fuller',
      lang: 'α',
      description:
        'This course will cover the last fifteen chapters of the textbook. The course will emphasize the phonology (the sounds) and morphology (the forms), along with a basic vocabulary of biblical Greek.',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Greek 2 Fall.pdf',
    },
    {
      id: 3,
      title: 'Theology 1',
      instructor: 'Russell Fuller',
      description:
        'This course overviews the theology of Scripture. Although the it has sixty-six books, the Bible has a consistent, unified teaching. This class will examine what Scriptures teach about such teachings as God, man before and after the fall, sin, Christ his person and work',
      time: 'Monday, 6:00pm-7:45pm',
      syllabus: 'Theology 1.pdf',
    },
    {
      id: 4,
      title: 'New Testament Survey 1',
      instructor: 'Russell Fuller',
      description:
        'This course overviews Matthew through Acts, observing various themes and topics of each book. Other topics of interest will also be discussed, such as the canon of the New Testament, and the inspiration of the New Testament, among others.',
      time: 'Monday, 8:00pm-9:45pm',
      syllabus: 'New Testament Survey 1.pdf',
    },
    {
      id: 5,
      title: 'The Book of Judges',
      instructor: 'Richard McDonald',
      description:
        'This course overviews the book of Judges, observing various themes and topics in the book, and especially how the rest of Scriptures (the New Testament in particular) helps to interpret the book of Judges, and just as importantly, how the book of Judges interprets the Old Testament.  Other topics of interest will also be discussed, such as the authorship and inspiration of the book of Judges, among others.',
      time: 'Monday, 8:00pm-9:45pm',
      syllabus: 'The Book of Judges.pdf',
    },
    {
      id: 6,
      title: 'The Epistles of John',
      instructor: 'Richard McDonald',
      description:
        'This course overviews the Epistles of John, observing various themes and topics in the book, and especially how the rest of Scriptures (the Old Testament in particular) helps to interpret the Epistles of John, and just as importantly, how the Epistles of John interprets the Old Testament.  Other topics of interest will also be discussed, such as the authorship and inspiration of the Epistles of John, among others.',
      time: 'Tuesday, 8:00pm-9:45pm',
      syllabus: 'The Epistles of John.pdf',
    },
    {
      id: 7,
      title: 'Hebrew 2',
      lang: 'א',
      instructor: 'Richard McDonald',
      description:
        'Hebrew I and II are introductory courses in the Hebrew language. All language study is difficult, requiring much time and effort. Although it becomes more difficult with age, language study is beneficial for the mind. It is strongly recommended that you do not take this course if you are taking first or second semester Greek (unless you have had Hebrew or Greek before, and one of the courses is review)',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Hebrew 2 Fall.pdf',
    },
    {
      id: 8,
      title: 'Greek 1',
      instructor: 'Kyoungwon Choi',
      lang: 'α',
      description:
        'Greek I and II are introductory courses in the Greek language. All language study is difficult, requiring much time and effort. Although it becomes more difficult with age, language study is beneficial for the mind.',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Greek 1 Fall.pdf',
    },
    {
      id: 9,
      title: 'Greek Composition',
      instructor: 'Russell Fuller',
      lang: 'α',
      description:
        'This course will cover eight compositions in the textbook and various sections of the textbook. The course will emphasize the syntax, accents, and exegesis of New Testament Greek. Some sections of the Greek New Testament will be read. Learning the syntax through the compositions is very important. Composition is a means to learning Greek syntax actively. To take this course you need to have taken Greek I and II or their equivalent, that is, to have completed a first-year Greek grammar book',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Greek Composition.pdf',
    },
    {
      id: 10,
      title: 'Hebrew Composition',
      instructor: 'Kyoungwon Choi',
      lang: 'א',
      description:
        'This course will cover first seven compositions and various sections of the textbook. The course will emphasize the syntax, accents, and exegesis of biblical Hebrew. Some sections of the Hebrew Old Testament will be read. Learning the syntax notes in the compositions is very important. Indeed, the purpose of the compositions is to learn the syntax in the notes and in the textbook. Composition is a means to that end. To take this course you need to have taken Hebrew I and II or their equivalent, that is, to have completed a first-year Hebrew grammar book.',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: `Hebrew_Syntax_Composition.pdf`,
    },
    {
      id: 11,
      title: 'Pastoral Ministry 101',
      instructor: 'Tom Rush',
      description:
      'This course is designed to give you a basic understanding of pastoral ministry.  Most of the topics that will be discussed are not covered in seminary. I can say that the material in this coursewas not taught at the seminary I attended. The purpose is to give you a biblical understanding of the call to preach/pastor, the character and lifestyle expected of a pastor, and the competency required to pastor a local church. I have a total of 39 years serving in pastoral ministry, 34 as a senior pastor and military chaplain, and five now as an evangelist and transitional pastor. There isnot much that can happen in a church that I have not experienced.',
      time: 'Tuesday, 8:00pm-9:45pm',
      syllabus: `Pastoral Ministry 101.pdf`,
    },
  ],
  "Winter 2022": [
    {
      id: 1,
      title: "Advanced Readings in the Greek New Testament",
      instructor: "Russell Fuller",
      lang: 'α',
      description: 'This advanced course will read various passages from the Greek New Testament, emphasizing the syntax and exegesis of New Testament Greek.',
      time: "Tuesdays and Thursdays 8:00pm-8:50pm",
      syllabus: "Advanced Readings in the Greek New Testament.pdf",
    },
    {
      id: 2,
      title: "Advanced Readings in the Hebrew Old Testament",
      instructor: "Kyoungwon Choi",
      lang: 'א',
      description: "This course focuses on reading selected passages in the Hebrew of the Old Testament books, emphasizing the syntax, exegesis, and theology of the books.",
      time: "Tuesdays and Thursdays 9:00pm-9:50pm",
      syllabus: "Advanced Readings in the Hebrew Old Testament.pdf",
    },
    {
      id: 3,
      title: "Greek 2",
      instructor: "Kyoungwon Choi",
      lang: 'α',
      description: "Greek I and II are introductory courses in the Greek language.",
      time: "Tuesdays and Thursdays 8:00pm-8:50pm",
      syllabus: "Greek 2.pdf",
    },
    {
      id: 4,
      title: "Hebrew 2",
      instructor: "Kyoungwon Choi",
      lang: 'א',
      description: "Hebrew I and II are introductory courses in the Hebrew language.",
      time: "Tuesdays and Thursdays 7:00pm-7:50pm",
      syllabus: "Hebrew 2.pdf",
    },
    {
      id: 5,
      title: "New Testament Survey 2",
      instructor: 'Russell Fuller',
      description: 'This course overviews Romans through Revelation, observing various themes and topics of each book.',
      time: 'Monday 8:00pm-9:45pm',
      syllabus: 'New Testament Survey 2.pdf'
    },
    {
      id: 6,
      title: 'Spiritual Gifts',
      instructor: 'Tom Rush',
      description: 'This course is designed to give you a basic understanding of the biblical system of spiritual gifts.',
      time: 'Tuesdays 8:00pm-9:45pm',
      syllabus: 'Spiritual_Gifts.pdf'
    },
    {
      id: 7,
      title: 'The Story of Joseph',
      instructor: 'Richard McDonald',
      description: 'This course overviews the story of Joseph in Genesis 37-50, observing various themes and topics in the account, and especially how the rest of Scriptures (the New Testament in particular) helps to interpret the story of Joseph, and just as importantly, how the story of Joseph interprets the Old Testament.',
      time: 'Monday 8:00pm-9:45pm',
      syllabus: 'The Story of Joseph.pdf'
    },
    {
      id: 8,
      title: 'Theology 2',
      instructor: 'Russell Fuller',
      description: 'This class will examine what Scriptures teach about such teachings as Christ his person and work, salvation, and eschatology.',
      time: 'Mondays 6:00pm-7:45pm',
      syllabus: 'Theology 2.pdf'
    }
  ],
  "Fall 2022": [
    {
      id: 1,
      title: 'Evangelism',
      instructor: 'Tom Rush',
      description: 'This course is designed to give you a basic biblical understanding of evangelism and its importance in the life of the New Testament church',
      time: 'Tuesdays 8:00pm-9:45pm',
      syllabus: 'Evangelism.pdf'
    },
    {
      id: 2,
      title: 'Greek 1',
      instructor: 'Kyoungwon Choi',
      lang: 'α',
      description: 'Greek 1 and 2 are introductory courses in the Greek language.',
      time: 'Tuesdays and Thursdays 8:00pm-8:50pm',
      syllabus: 'Greek 1.pdf'
    },
    {
      id: 3,
      title: '1 and 2 Peter',
      instructor: 'Richard McDonald',
      description: 'This course offers an overview of the books of 1 and 2 Peter, observing various themes and topics in the account',
      time: 'Thursdays 8:00pm-9:45pm',
      syllabus: '1 and 2 Peter.pdf'
    },
    {
      id: 4,
      title: 'Greek 3, Syntax (Composition)',
      instructor: 'Russell Fuller',
      lang: 'α',
      description: 'This course will emphasize the syntax, accents, and exegesis of New Testament Greek.',
      time: 'Tuesdays and Thursdays 8:00pm-8:50pm',
      syllabus: 'Greek 3, Syntax (Composition).pdf'
    },
    {
      id: 5,
      title: 'Hebrew 1',
      instructor: 'Kyoungwon Choi',
      lang: 'א',
      description: 'Hebrew 1 and 2 are introductory courses in the Hebrew language.',
      time: 'Tuesdays and Thursdays  7:00pm-7:50pm',
      syllabus: 'Hebrew 1.pdf'
    },
    {
      id: 6,
      title: 'Hebrew 3, Syntax (Composition)',
      instructor: 'Kyoungwon Choi',
      lang: 'א',
      description: 'This course will emphasize the syntax, accents, and exegesis of biblical Hebrew.',
      time: 'Tuesdays and Thursdays 9:00pm-9:50pm',
      syllabus: 'Hebrew 3, Syntax (Composition).pdf'
    },
    {
      id: 7,
      title: 'Old Testament Theology',
      instructor: 'Russell Fuller',
      description: 'This course overviews the theology of the Old Testament.',
      time: 'Mondays 6:00pm-7:45pm',
      syllabus: 'Old Testament Theology.pdf'
    },
    {
      id: 8,
      title: 'The Pentateuch',
      instructor: 'Russell Fuller',
      description: 'This course overviews the Pentateuch, Genesis through Deuteronomy, observing various themes and topics of each book',
      time: 'Mondays 8:00pm-9:45pm',
      syllabus: 'The Pentateuch.pdf'
    },
  ],
  "Winter 2023": [
    {
      id: 1,
      title: 'Advanced Greek',
      instructor: 'Kyoungwon Choi',
      lang: 'α',
      description: 'This advanced course will read various passages from the Greek New Testament, emphasizing the syntax and exegesis of New Testament Greek',
      time: 'Tuesdays and Thursdays 9:00pm-9:50pm',
      syllabus: 'Advanced Greek.pdf'
    },
    {
      id: 2,
      title: 'Biblical Theology 2',
      instructor: 'Russell Fuller',
      description:
        'This course continues the overview of biblical theology. This class will examine the development of biblical teachings concerning the coming of man, sin, salvation, law, perseverance of the saints, assurance of salvation, death and the afterlife.',
      time: 'Mondays 6:00pm-7:45pm',
      syllabus: 'Biblical Theology 2.pdf'
    },
    {
      id: 3,
      title: 'Pastoral Epistles',
      instructor: 'Tom Rush',
      description: 'This course is designed to give you a basic biblical understanding of the Pastoral Epistles, First and Second Timothy, and Titus.',
      time: 'Tuesdays 8:00pm-9:45pm',
      syllabus: 'Pastoral Epistles.pdf'
    },
    {
      id: 4,
      title: 'Hebrew 2',
      instructor: 'Russell Fuller',
      lang: 'א',
      description:
        'This course will cover the last fourteen chapters of the textbook, one chapter per week usually and two chapters in the first week. The course will emphasize the weak verb, its phonology (the sounds) and morphology (the forms), along with a basic vocabulary of biblical Hebrew.',
      time: 'Tuesday & Thursday, 7:00pm-7:50pm',
      syllabus: 'Hebrew 2.pdf',
    },
    {
      id: 5,
      title: "Greek 2",
      instructor: "Kyoungwon Choi",
      lang: 'α',
      description: "Greek I and II are introductory courses in the Greek language.",
      time: "Tuesdays and Thursdays 8:00pm-8:50pm",
      syllabus: "Greek 2.pdf",
    },
    {
      id: 6,
      title: 'Advanced Hebrew',
      instructor: 'Russell Fuller',
      lang: 'א',
      description: 'This advanced course will read various passages from the Hebrew Old Testament, emphasizing the syntax and exegesis of Old Testament Hebrew.',
      time: 'Tuesdays and Thursdays 8:00pm-8:50pm',
      syllabus: 'Advanced Hebrew.pdf'
    },
    {
      id: 7,
      title: 'Psalms',
      instructor: 'Richard McDonald',
      description: 'This course overviews the book of Psalms, observing various themes and topics, and especially how the rest of Scriptures (the New Testament in particular) helps to interpret the Psalms',
      time: 'Thursdays 8:00pm-9:45pm',
      syllabus: 'Psalms.pdf'
    }
  ],
  "Fall 2023": [
    {
      id: 1,
      title: 'Biblical Theology III',
      instructor: 'Russell Fuller',
      description: 'This course continues the overview of biblical theology. This class will examine the development of biblical teachings between the Old and New Testaments concerning the adoption, sanctification, law, perseverance of the saints, assurance of salvation, death and the afterlife, and other topics.',
      time: 'Mondays 6:00pm-7:45pm',
      syllabus: 'Biblical Theology 3.pdf'
    },
    {
      id: 2,
      title: 'Aramaic',
      instructor: 'Russell Fuller',
      lang: 'א',
      description: 'Aramaic I is an introductory course in the Aramaic language.',
      time: 'Mondays 8:00pm-9:45pm',
      syllabus: 'Aramaic 1.pdf'
    },
    {
      id: 3,
      title: 'Biblical Doctrine of Holiness',
      instructor: 'Tom Rush',
      description: 'This course is designed to give you a basic biblical understanding of the doctrine of holiness.',
      time: 'Tuesdays 8:00pm-9:45pm',
      syllabus: 'Biblical Doctrine of Holiness.pdf'
    },
    {
      id: 4,
      title: 'The Book of Proverbs',
      instructor: 'Richard McDonald',
      description: 'This course overviews the book of Proverbs, observing various themes and topics, and especially how the rest of Scriptures (the New Testament in particular) helps to interpret the book of Proverbs, and just as importantly, how Proverbs interprets the Old Testament.',
      time: 'Thursdays 8:00pm-9:45pm',
      syllabus: 'Proverbs.pdf'
    },
    {
      id: 5,
      title: 'Advanced Greek (with Composition)',
      instructor: 'Russell Fuller',
      lang: 'α',
      description: 'This advanced course will read various passages from the Greek New Testament, emphasizing the syntax and exegesis of New Testament Greek.',
      time: 'Tuesdays and Thursdays 7:00pm-7:50pm',
      syllabus: 'Advanced Greek (with Composition) Fall 2023.pdf'
    },
    {
      id: 6,
      title: 'Advanced Hebrew (with Composition)',
      instructor: 'Russell Fuller',
      lang: 'א',
      description: 'This advanced course will read various passages from the Hebrew Old Testament, emphasizing the syntax and exegesis of Old Testament Hebrew.',
      time: 'Tuesdays and Thursdays 8:30pm-9:20pm',
      syllabus: 'Advanced Hebrew (with Composition)Fall 2023.pdf'
    },
  ],
  "Winter 2024": [
    {
      id: 1,
      title: 'Advanced Greek',
      instructor: 'Russell Fuller',
      lang: 'α',
      description: 'This advanced course will read various passages from the Greek New Testament, emphasizing the syntax and exegesis of New Testament Greek',
      time: 'Tuesdays and Thursdays 7:00pm-7:50pm',
      syllabus: 'Advanced Greek.pdf'
    },
    {
      id: 2,
      title: 'Aramaic 2',
      instructor: 'Russell Fuller',
      lang: 'א',
      description:
        'Aramaic II is an introductory course in the Aramaic language. It is recommended that you have Aramaic I before taking this course.',
      time: 'Mondays 8:00pm-9:45pm',
      syllabus: 'Aramaic 2.pdf'
    },
    {
      id: 3,
      title: 'Ezra and Nehemiah',
      instructor: 'Tom Rush',
      description: 'This course is designed to give you a basic understanding of the books of Ezra and Nehemiah, covering the period of time that the people of Israel returned to Jerusalem following the Babylonian captivity',
      time: 'Tuesdays 8:00pm-9:45pm',
      syllabus: 'Ezra Nehemiah Syllabus.pdf'
    },
    {
      id: 4,
      title: 'Issues in Theology',
      instructor: 'Russell Fuller',
      description:
        'This course will discuss selected issues in theology. The topics will discuss issues of interpretation such as using Ancient Near Eastern materials to interpret Scripture. Also theological topics on the name of God, the Trinity, the image of God, and the preservation of Scripture will be included',
      time: 'Mondays 6:00pm-7:45pm',
      syllabus: 'Issues in Theology.pdf',
    },
    {
      id: 5,
      title: 'Advanced Hebrew',
      instructor: 'Russell Fuller',
      lang: 'א',
      description: 'This advanced course will read various passages from the Hebrew Old Testament, emphasizing the syntax and exegesis of Old Testament Hebrew.',
      time: 'Tuesdays and Thursdays 8:30pm-9:20pm',
      syllabus: 'Advanced Hebrew.pdf'
    },
    {
      id: 6,
      title: 'Gospel of Mark',
      instructor: 'Richard McDonald',
      description: 'This course overviews the book of Mark, observing various themes and topics, and especially how the rest of Scriptures (the Old Testament in particular) helps to interpret the Mark',
      time: 'Thursdays 8:00pm-9:45pm',
      syllabus: 'Gospel of Mark.pdf'
    }
  ],
}
